import {
	IsEnabledPath,
	QueryAgentPath,
	RAGControllerPath,
	RagQueryPayload,
	urlCombine,
} from 'ihub/common';
import { coreAPI, handleResponse, standardGet, standardPost } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class RagAiHttpService {
	async isEnabled(options?: HttpResponseOptions) {
		const url = urlCombine(coreAPI, RAGControllerPath, IsEnabledPath);
		const response = await standardGet(url);
		await handleResponse(response, 'Is Enabled', RAGControllerPath, options);
	}

	async sendQuestion(ragQueryPayload: RagQueryPayload, options?: HttpResponseOptions) {
		const url = urlCombine(coreAPI, RAGControllerPath, QueryAgentPath);
		const response = await standardPost(url, ragQueryPayload);
		await handleResponse(response, 'Send Question', RAGControllerPath, options);
	}
}
